export const baseApiUrl = 'https://api.mgimobil.app.br' // web
export const baseFrotendUrl = 'https://mgimobil.app.br' // web

export default { baseApiUrl, baseFrotendUrl }
